import { useSelector } from 'react-redux';

import Form from 'app/components/Form';
import { formatOptions } from 'app/utils/options';

import {
  getSimpleJobs
} from 'app/services/jobs';

const CustomerForm = props => {
  const {
    customer,
    onClose,
    onSubmit,
    action,
    job,
    kioskOptions
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  const account = useSelector(state => state.portalReducer.account);

  const getJobOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let jobs = await getSimpleJobs();
    return formatOptions(jobs);
  }

  let fields = [];

  // if a job has been passed in the props,
  // then set the job to the job select and hide it.
  // if the kiosk_mode feature flag is enabled,
  // then show the kiosk instead but follow the same logic
  if (account?.feature_flags.kiosk_mode) {
    fields.push({ name: 'kiosk_id', label: 'Kiosk', type: 'select', value: job?.kiosk_id, valueType: 'integer', options: kioskOptions, helperText: 'Kiosk that customer belongs to', hidden: !!job, hideNoneOption: true });
  } else {
    fields.push({ name: 'job_id', label: 'Job', type: 'autocomplete', value: job?.id || customer?.job_id, valueType: 'integer', getOptions: getJobOptions, required: true, helperText: 'Job that customer belongs to', hidden: !!job });
  }

  // enable either single name field or first and last name.
  // hard coded to first and last name for now, but the single name field
  // can be enabled for locales or situations where its desired.
  // this can be made into an account flag.
  // for now it defaults to splitting unless this is an existing customer
  // and there's no first or last name set
  let splitNameField = !customer || customer.first_name || customer.last_name;
  if (splitNameField) {
    // note - styling would be better with flexbox, as in DateTimePicker
    let fieldStyle = {
      width: 'calc(50% - 0.5rem)',
      marginRight: '0.5rem'
    }

    fields.push({
      type: 'inline',
      fields: [
        { name: 'first_name', label: 'First Name', type: 'text', value: customer?.first_name, sx: fieldStyle, helperText: "Given name" },
        { name: 'last_name', label: 'Last Name', type: 'text', value: customer?.last_name, sx: fieldStyle, helperText: "Family name" }
      ]
    });

  } else {
    fields.push({ name: 'name', label: 'Name', type: 'text', value: customer?.name, helperText: "Full name" });
  }

  fields = fields.concat([
    { name: 'email', label: 'Email', type: 'text', value: customer?.email, helperText: "Email address" },
    { name: 'phone', label: 'Phone', type: 'text', value: customer?.phone, helperText: "Phone number" },
    { name: 'access_code', label: 'Access Code', type: 'text', value: customer?.access_code, helperText: "Access code" }
  ]);

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default CustomerForm;

